import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, Primitive, Text } from '@rtkwlf/fenrir-react';
import { faSearch } from '@rtkwlf/pro-regular-svg-icons/faSearch';
import { useTranslation } from 'react-i18next';

type NoDataProps = { message?: string; withIcon?: boolean };

/** @deprecated Please use EmptyState from packages/fenrir */
export const NoData: React.FC<NoDataProps> = ({
  message,
  withIcon = false,
}) => {
  const { t } = useTranslation();

  return (
    <Primitive.div
      textAlign="center"
      display="flex"
      flexDirection="column"
      height="full"
      alignItems="center"
      justifyContent="center"
      marginBottom="large"
      marginTop="large"
    >
      {withIcon ? (
        <FontAwesomeIcon
          icon={faSearch}
          color={`rgb(${colors.icon.neutral.default})`}
          style={{
            height: '50px',
            opacity: '0.5',
            width: '55px',
          }}
        />
      ) : null}
      <Text>{message ?? t('layouts:common.noData')}</Text>
    </Primitive.div>
  );
};
